<template>
  <div v-if="isLoggedIn">
    <NavbarTop></NavbarTop>
    <b-row>
      <SidebarLeft></SidebarLeft>
    </b-row>

    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
  <div v-else>
    <Login></Login>
  </div>
</template>

<script>
  import NavbarTop from "./components/NavbarTop.vue"
  import SidebarLeft from "./components/SidebarLeft.vue"
  import Login from "./pages/Login.vue"
  import {TokenService} from "./storage/service"
  
  export default {
    name: 'App',
    components: {
      NavbarTop,
      SidebarLeft,
      Login
    },
    created: function () {
      if(TokenService.getToken()){
        this.$http.defaults.headers.common = {
          "Authorization": "Token " + TokenService.getToken(),
        };
      }
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function () {
          if ((err.status === 401 || err.status === 403 || err.status === 404 || err.status === 407) && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch('logout')
          }
          throw err;
        });
      });

    },

    mounted() {
    },
    methods: {
      
    },

    computed : {
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
    },
  } 
</script>

<style>

body {
    font-size: .875rem;
  }

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
